<template>
  <section class="about-us-section">
    <div class="container">
      <!-- Section Header -->

      <!-- CEO Section -->

      <div class="leader-profile founder-row">
        <div class="profile-visual animate-up delay-1">
          <div class="image-wrapper">
            <img
              src="@/assets/images/VipandeepSingh.png"
              alt="Vipandeep Singh"
              class="profile-img"
            />
            <div class="floating-badge">
              <span class="years">VIPANDEEP SINGH</span>
              <span class="focus">Founder, Client's Preferred</span>
            </div>
          </div>
        </div>

        <div class="profile-info animate-up delay-2">
          <div class="info-header">
            <span class="role-tag">Excellence & Integrity</span>
            <h2 class="name">Vipandeep Singh</h2>
            <p class="title">Founder, Clients Preferred Property Hub</p>
          </div>

          <div class="bio-text">
            <p>
              Vipandeep Singh is a visionary entrepreneur, real estate advisor,
              and venture builder with a growing portfolio of businesses across
              multiple sectors. He is the founder of Clients Preferred Property
              Hub, a trust-driven real estate consultancy focused on verified,
              GMADA & RERA-approved projects across Tricity.
            </p>
            <p>
              With deep local market knowledge and a hands-on leadership
              approach, he helps homebuyers and investors make informed,
              future-ready decisions while simultaneously expanding ventures
              that align with transparency, quality, and credibility.
            </p>
            <p>
              Beyond real estate advisory, Vipandeep is actively building and
              scaling multiple ventures. For him, business is not just about
              growth — it’s about building trusted brands and lasting impact.
            </p>
          </div>

          <div class="stats-row">
            <div class="stat-box">
              <span class="stat-num">100%</span>
              <span class="stat-desc">Client Focused</span>
            </div>
            <div class="stat-box">
              <span class="stat-num">GTA</span>
              <span class="stat-desc">Expertise</span>
            </div>
          </div>

          <div class="contact-strip">
            <a
              href="https://www.google.com/maps/search/?api=1&query=Gillco+Valley+Sector-127+Kharar+Mohali"
              target="_blank"
              class="action-link"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
              <span>Gillco Valley Sector-127, Mohali</span>
            </a>
            <a href="tel:+917087931778" class="action-link">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                ></path>
              </svg>
              <span>+91-70879 31778</span>
            </a>
          </div>
        </div>
      </div>

      <div class="profile-divider"></div>

      <!-- COO Section (Reversed) -->

      <div class="leader-profile coo-row">
        <div class="profile-info animate-up delay-1">
          <div class="info-header">
            <span class="role-tag">Operations & Strategy</span>
            <h2 class="name">Mohit Phutela</h2>
            <p class="title">Chief Operating Officer</p>
          </div>

          <div class="bio-text">
            <p>
              Mohit Phutela specializes in helping clients seamlessly bridge the
              gap between discovering the right property and securing the most
              suitable financing solutions. With over 3 years of experience in
              residential real estate, he brings a unique, data-driven
              perspective to the tricity.
            </p>
            <p>
              His expertise lies in simplifying complex real estate deals by
              offering clear insights, strategic planning, and end-to-end
              support. Mohit is committed to ensuring that every investment
              decision is not only smooth but also aligned with long-term
              profitability.
            </p>
            <p>
              Whether you are a first-time homebuyer or a seasoned investor,
              Mohit provides proactive guidance backed by market
              analysis—helping you make confident, well-informed decisions that
              optimize your ROI.
            </p>
          </div>

          <div class="contact-strip">
            <a href="tel:+919888880784" class="action-link">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                ></path>
              </svg>
              <span>+91-98888 80784</span>
            </a>
          </div>
        </div>

        <div class="profile-visual animate-up delay-2">
          <div class="image-wrapper">
            <img
              src="@/assets/images/MohitPhutela.png"
              alt="Mohit Phutela"
              class="profile-img"
            />
            <div class="floating-badge dark">
              <span class="years">MOHIT PHUTELA</span>
              <span class="focus">Chief Operating Officer</span>
            </div>
          </div>
        </div>
      </div>

      <div class="profile-divider"></div>
      <!--CMO-->

      <div class="leader-profile founder-row">
        <div class="profile-visual animate-up delay-1">
          <div class="image-wrapper">
            <img
              src="@/assets/images/AnkitSuryavanshi.png"
              alt="Vipandeep Singh"
              class="profile-img"
            />
            <div class="floating-badge">
              <span class="years">ANKIT SURYAVANSHI</span>
              <span class="focus">Chief Marketing Officer</span>
            </div>
          </div>
        </div>

        <div class="profile-info animate-up delay-2">
          <div class="info-header">
            <span class="role-tag">Growth & Governance</span>
            <h2 class="name">Ankit Suryavanshi</h2>
            <p class="title">Chief Marketing Officer</p>
          </div>

          <div class="bio-text">
            <p>
              At Clients Preferred Property Hub, our marketing vision is driven
              by innovation, trust, and meaningful client relationships. As the
              Chief Marketing Officer, my focus is on building a strong brand
              presence while ensuring every client receives accurate guidance,
              transparent communication, and real value in their property
              journey.
            </p>
            <p>
              With deep local market knowledge and a hands-on leadership
              approach, he helps homebuyers and investors make informed,
              future-ready decisions while simultaneously expanding ventures
              that align with transparency, quality, and credibility.
            </p>
            <p>
              I believe real estate marketing is not just about promoting
              properties — it is about understanding people, their goals, and
              helping them invest wisely for the future. At Clients Preferred
              Property Hub, we are committed to delivering credibility,
              professionalism, and long-term value through every interaction.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
/* Base Styles */

.profile-divider {
  position: relative;
  height: 2px;
  width: 100%;
  max-width: 900px;
  margin: 100px auto;

  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(185, 28, 28, 0.4) 20%,
    rgba(185, 28, 28, 0.8) 50%,
    rgba(185, 28, 28, 0.4) 80%,
    transparent 100%
  );
}
.about-us-section {
  padding: 100px 0;
  background: linear-gradient(180deg, #ffffff 0%, #f5f5f5 100%);
  padding: 100px 0;
  border-top: 1px solid #f0f0f0;
  color: #1a1a1a;
  overflow: hidden;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Header Styling */
.section-intro {
  text-align: center;
  margin-bottom: 80px;
}

.sub-heading {
  display: block;
  font-weight: 700;
  color: #b91c1c;
  text-transform: uppercase;
  letter-spacing: 3px;
  font-size: 0.9rem;
  margin-bottom: 10px;
}

.main-heading {
  font-size: clamp(2rem, 5vw, 3rem);
  font-weight: 800;
  color: #111;
  margin-bottom: 20px;
}

.header-line {
  width: 60px;
  height: 4px;
  background: #b91c1c;
  margin: 0 auto;
}

/* Layout Grid */
.leader-profile {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
  margin-bottom: 120px;
}

/* Image Wrapper Effects */
.image-wrapper {
  position: relative;
  z-index: 1;
}

.profile-img {
  width: 100%;
  aspect-ratio: 4/5;
  object-fit: cover;
  border-radius: 4px;
  filter: grayscale(20%);
  transition: all 0.5s ease;
  border: 1px solid #a9a5a5;
}

.image-wrapper::before {
  content: '';
  position: absolute;
  top: 20px;
  left: 20px;
  right: -20px;
  bottom: -20px;
  border: 4px solid #ffffff;
  z-index: -1;
  border-radius: 4px;
}

.leader-profile:hover .profile-img {
  filter: grayscale(0%);
  transform: translateY(-5px);
}

/* Floating Badge */
.floating-badge {
  position: absolute;
  bottom: 30px;
  right: -10px;
  background: #b91c1c;
  color: white;
  padding: 15px 25px;
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
}

.floating-badge .years {
  font-weight: 800;
  font-size: 1.2rem;
  letter-spacing: 1px;
  margin-bottom: 3px;
}

.floating-badge .focus {
  font-size: 0.75rem;
  text-transform: uppercase;
  opacity: 0.9;
}

/* Content Area */
.role-tag {
  color: #b91c1c;
  font-weight: 700;
  font-size: 0.8rem;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.name {
  font-size: 2.5rem;
  margin: 10px 0 5px;
  font-weight: 800;
}

.title {
  font-size: 1.1rem;
  color: #666;
  font-style: italic;
  margin-bottom: 30px;
}

.bio-text p {
  font-size: 1.05rem;
  line-height: 1.7;
  color: #444;
  margin-bottom: 20px;
}

/* Stats Styling */
.stats-row {
  display: flex;
  gap: 50px;
  margin: 35px 0;
  border-left: 3px solid #f3f4f6;
  padding-left: 25px;
}

.stat-num {
  display: block;
  font-size: 1.8rem;
  font-weight: 800;
  color: #111;
}

.stat-desc {
  font-size: 0.8rem;
  color: #b91c1c;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 1px;
}

/* Contact Links */
.contact-strip {
  display: flex;
  flex-wrap: wrap;
  gap: 25px;
  margin-top: 30px;
}

.action-link {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: #111;
  font-weight: 700;
  font-size: 0.95rem;
  transition: all 0.3s ease;
}

.action-link svg {
  color: #b91c1c;
}

.action-link:hover {
  color: #b91c1c;
  transform: translateX(5px);
}

/* Responsive Logic */
@media (max-width: 992px) {
  .leader-profile {
    grid-template-columns: 1fr;
    gap: 50px;
  }

  .coo-row .profile-info {
    order: 2;
  }

  .coo-row .profile-visual {
    order: 1;
  }

  .image-wrapper {
    max-width: 500px;
    margin: 0 auto;
  }

  .name {
    font-size: 2rem;
  }

  .stats-row {
    justify-content: space-around;
    border-left: none;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    padding: 20px 0;
  }
}
</style>
